export default __webpack_public_path__ + "media/vitalitySeo.bcc65c6ad0e06365d6af6234784445ec.webp";